import axios from "axios";
import { resolve } from "./resolve.js";
import { API_AUTH_URL } from "../constants/consts";
import { getSession } from "./sessionManagement";
import { getExchangeHeaders } from "./helpers";

export interface BlockPageSettings {
  id: number;
  name: string;
  start_date: string;
  end_date: string;
  priority: number;
  is_page_active: boolean;
  text: string;
}

export interface IsBlockedAccessResponse {
  is_blocked_access: boolean;
}

export interface BlockPageSettingsResponse {
  data: BlockPageSettings[];
}

export async function checkIsBlockedAccess(sessionIdOverride?: string | null): Promise<{
  data?: IsBlockedAccessResponse;
  error?: any;
}> {
  const sessionId = sessionIdOverride ?? getSession();
  if (!sessionId) {
    return { data: { is_blocked_access: false } };
  }

  return await resolve(
    axios.get(
      `${API_AUTH_URL}/users/is_blocked_access`,
      {
        headers: {
          session_id: sessionId,
        },
      }
    ).then((res) => res.data)
  );
}

export async function getBlockPageSettings(sessionIdOverride?: string | null): Promise<{
  data?: BlockPageSettingsResponse;
  error?: any;
}> {
  const sessionId = sessionIdOverride ?? getSession();
  if (!sessionId) {
    return { data: { data: [] } };
  }

  return await resolve(
    axios.get(
      `${API_AUTH_URL}/users/block_page_settings`,
      {
        headers: {
          ...getExchangeHeaders(),
          session_id: sessionId,
        },
      }
    ).then((res) => res.data)
  );
}
